import Textarea from './ui/Textarea';

/**
 * Condition-6 ("Removed / Disconnected") confirm form for RecordTestModal.
 *
 * Replaces the normal test-type/result/checklist block when the tech sets the
 * asset condition to 6: no pass/fail is recorded, only a 'removed' result and a
 * deferred status flip at session finish. Renders a short confirm message plus
 * the shared Comments field.
 *
 * Props:
 *   register — react-hook-form register fn (used for `commentsRecommendations`).
 */
export default function RemovedAssetConfirm({ register }) {
  return (
    <div className="removed-asset-confirm">
      <div className="form-group">
        <p className="text-muted">
          This fitting will be marked <strong>Removed / Disconnected</strong> — no pass/fail result
          will be recorded.
        </p>
      </div>

      <Textarea
        id="record-test-comments"
        label="Comments & recommendations"
        rows={4}
        placeholder="Optional: reason for removal, follow-up, or extra detail."
        {...register('commentsRecommendations')}
      />
    </div>
  );
}
